import React from 'react';

import AppSettings from 'app/appSettings';
import CookiesBanner from 'components/CookiesBanner';
import Keycloak, { KeycloakInitOptions } from 'keycloak-js';
import ReactGA from 'react-ga';
import { Provider } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import FragnetService from 'services/FragnetService';
import LocalStorageService from 'services/LocalStorageService';

import { ReactKeycloakProvider } from '@react-keycloak/web';
import { AuthClientTokens } from '@react-keycloak/core';

import HomeRoute from './HomeRoute';
import { store } from './store';

const keycloak = Keycloak(process.env.PUBLIC_URL + '/keycloak.json');

if (!!AppSettings.GANALYTICS_ID) {
  ReactGA.initialize(AppSettings.GANALYTICS_ID);
  ReactGA.pageview(window.location.pathname + window.location.search);
}

const keycloakInitOptions: KeycloakInitOptions = {
  onLoad: 'check-sso',
};

const onKeycloakTokens = (tokens: AuthClientTokens) => {
  if (tokens.token) {
    FragnetService.setToken(tokens.token);
    LocalStorageService.saveKeycloakTokens(tokens);
  }
};

const App = () => {
  // The app could be deployed without specifying critical constants. So instruct to specify these.
  if (!AppSettings.FRAGNET_SEARCH_SERVER || !AppSettings.FRAGNET_DEPICT_SERVER) {
    return (
      <p>
        Please specify <code>FRAGNET_SEARCH_SERVER</code> and
        <code>FRAGNET_DEPICT_SERVER</code> in the <code>config.json </code>
        {process.env.NODE_ENV === 'development' && (
          <>
            or your <code>.env.development.local</code>
          </>
        )}
      </p>
    );
  }
  return (
    <>
      <Provider store={store}>
        <ReactKeycloakProvider
          authClient={keycloak}
          initOptions={keycloakInitOptions}
          onTokens={onKeycloakTokens}
        >
          <BrowserRouter basename={process.env.PUBLIC_URL}>
            <HomeRoute />
          </BrowserRouter>
        </ReactKeycloakProvider>
      </Provider>
      <CookiesBanner />
    </>
  );
};

export default App;
